import script from "./dol-edit-form.vue?vue&type=script&lang=js"
export * from "./dol-edit-form.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__